export default "/images/logo_home.svg?68821536188ab10a3c4abc38e8656a5f";